import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  label: {
    cursor: 'pointer'
  },
  disabled: {
    cursor: 'not-allowed'
  }
});

export const FormCheckbox = ({ value, onChange, label, disabled }) => {
  const classes = useStyles();
  function onClick () {
    if (!disabled) {
      onChange(!value);
    }
  }

  return (
    <span onClick={onClick} className={disabled ? classes.disabled : ''}>
      <Checkbox disabled={disabled} checked={value} color='primary' />
      {
        label
          ? <label className={disabled ? classes.disabled : classes.label}>{label}</label>
          : null
      }
    </span>
  );
};

FormCheckbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node
};

export default FormCheckbox;
